const handleCart = async () => {
  const cart_res = await fetch('/cart.js');
  const cart_json = await cart_res.json()
  let cart_items = cart_json.items;
  let cont = false;
  cart_items.forEach(item => {
    if (item.hasOwnProperty('Order Type') && item.properties['Order Type'] == "Ready to ship") {
      cont = true
    }
  })
  if (cont) {

    let ioh_fetch_data = cart_items.map((item) => {
      return {'sku': item.sku, properties: item.properties};
    });

    const res = await fetch('https://ioh-aria.herokuapp.com/glovecheck', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify(ioh_fetch_data)
    })
    const api_dat = await res.json();

    let sold_out_trigger = false;

    for (let i = 0; i < api_dat.length; i++) {
      let api_item = api_dat[i];
      let cart_item = cart_items[i];
      console.log(api_item)
      console.log(cart_item)
      if (! api_item['Exists']) {
        sold_out_trigger = true;
        let req_data = {
          id: `${
            parseInt(cart_item.id)
          }`,
          quantity: `${
            parseInt(0)
          }`
        }
        console.log(req_data)
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json'
          },
          body: JSON.stringify(req_data)
        }).then((response) => response.json()).then((data) => {
          cart_item.properties["Order Type"] = 'Custom'
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'dataType': 'json'
            },
            body: JSON.stringify(
              {
                  id: `${
                  cart_item['variant_id']
                }`,
                quantity: `${
                  cart_item.quantity
                }`,
                properties: cart_item.properties
              }
            )
          }).then((response) => response.json()).then((data) => {
            console.log(data)
            const cart_row = document.querySelector('.cart__row#cart-' + cart_item.id);
            if (cart_row) {
              cart_row.querySelector('.grid__item.three-quarters').innerHTML = cart_row.querySelector('.grid__item.three-quarters').innerHTML.replace('Ready to ship', 'Custom');
            }
          })
        })
      }
    }
    if (sold_out_trigger) {
      alert('One or more inventory on hand items in your cart are no longer available. We have changed the order type to custom for you.')
    }
  }
};
handleCart();